import type { BreakdownColor } from "./components/banner/breakdown-bar";
import type { RewardCategory } from "./types";

export interface CategoryDisplay {
  color: BreakdownColor;
  labelKey: string;
}

export const CATEGORY_DISPLAY: Record<RewardCategory, CategoryDisplay> = {
  fee_rebate: { color: "amber.500", labelKey: "feeRebate" },
  maker_rebate: { color: "yellow.500", labelKey: "makerRebate" },
  volume_milestone: { color: "cream.200", labelKey: "volumeMilestone" },
  liquidation_credit: { color: "lilac.100", labelKey: "liquidationCredit" },
  first_funded_trial: { color: "red.100", labelKey: "firstFundedTrial" },
  affiliate: { color: "green.150", labelKey: "affiliate" },
  other: { color: "light.500", labelKey: "others" },
};

export const BREAKDOWN_ORDER: RewardCategory[] = [
  "fee_rebate",
  "maker_rebate",
  "volume_milestone",
  "liquidation_credit",
  "first_funded_trial",
  "affiliate",
  "other",
];
